module.exports = __webpack_public_path__ + "static/img/Asset 4.4d36618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asset 4.png
// module id = 753
// module chunks = 0